import React from "react";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import MPage from "../templates/mpage";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";
import useObtenerPropuesta from "../../utils/useObtenerPropuesta";

const Propuesta = (props) => {
  const [municipio, errorMunicipio] = useObtenerMunicipio(
    props.match.params.munUrl
  );
  const [propuesta, errorPropuesta] = useObtenerPropuesta(
    props.match.params.propuestaId
  );

  if (errorMunicipio === true || errorPropuesta === true)
    return <Redirect to="/" />;
  if (municipio === undefined || propuesta === undefined) return null;
  if (propuesta.estado === "eliminada" || propuesta.estado === "pendiente") {
    return <Redirect to="/" />;
  }

  const decisiones = {
    aceptada: "¡Propuesta aprobada para votación!",
    seleccionada: "¡Propuesta seleccionada para ejecución!",
    archivada: "Propuesta archivada.",
  };

  const decision = decisiones[propuesta.estado];

  const shareUrl = `https://presupuestoparticipativo.unc.edu.ar/municipio/${municipio.nombreUrl}/propuesta/${propuesta._id}`;
  const title = "¡Ayudame a hacer este proyecto realidad!";

  return (
    <MPage municipio={municipio}>
      <img
        src={`/api/public/${propuesta.img}`}
        className="img-fluid mx-auto d-block img-propuesta"
        alt={propuesta.titulo}
      />
      <div className="centrado">
        <h3 className="font-weight-light"> {decision}</h3>
        <h2 className="ppr-titulo"> PROPUESTA: {propuesta.titulo}</h2>

        <FacebookShareButton url={shareUrl} quote={title} className="m-2 ">
          <FontAwesomeIcon
            icon={faFacebook}
            color="#0a4797"
            title="Compartir en Facebook."
            size="2x"
          />
        </FacebookShareButton>

        <TwitterShareButton url={shareUrl} quote={title} className="m-2 ">
          <FontAwesomeIcon
            icon={faTwitter}
            color="#0a4797"
            title="Compartir en Twitter."
            size="2x"
          />
        </TwitterShareButton>

        <WhatsappShareButton url={shareUrl} quote={title} className="m-2">
          <FontAwesomeIcon
            icon={faWhatsapp}
            color="#0a4797"
            title="Compartir por Whatsapp."
            size="2x"
          />
        </WhatsappShareButton>

        {municipio.etapa === "seleccion" &&
          propuesta.estado === "seleccionada" && (
            <h3>
              <b>Estado de Ejecución: {propuesta.ejecucion}</b>
            </h3>
          )}
        <h4 className="font-weight-light">{propuesta.subtitulo}</h4>
        {propuesta.eje && (
          <h4 className="font-weight-light">
            Eje de la Propuesta: {propuesta.eje}
          </h4>
        )}
        <h4 className="font-weight-light">
          Presupuesto Estimado: ${propuesta.presupuesto}
        </h4>
        <h4 className="font-weight-light">Por: {propuesta.autor}</h4>
        {municipio.etapa === "votacion" &&
          municipio.tipoVotacion === "publica" &&
          municipio.nombreUrl !== "laboulaye2024" && (
            <center>
              <Link
                to={`/municipio/${municipio.nombreUrl}/votacion/${propuesta._id}`}
                className="btn ppr-btn-verde font-weight-bold m-2"
              >
                VOTA ESTA PROPUESTA
              </Link>
            </center>
          )}
      </div>

      {municipio.msjProp !== "" && (
        <div className="card my-3" key="mensaje">
          <div className="card-header small fondo-celeste">
            MENSAJE IMPORTANTE
          </div>
          <div className="card-body" style={{ whiteSpace: "pre-line" }}>
            {municipio.msjProp}
          </div>
        </div>
      )}

      <div>
        {propuesta.observaciones.map((obs, index) => (
          <div className="card mb-3" key={index}>
            <div className="card-header small fondo-celeste">
              OBSERVACIÓN ({obs.fecha})
            </div>
            <div className="card-body" style={{ whiteSpace: "pre-line" }}>
              {obs.mensaje}
            </div>
          </div>
        ))}
      </div>
      <div style={{ whiteSpace: "pre-line" }}>{propuesta.descripcion}</div>
      {propuesta.doc && (
        <center className="m-3">
          <a
            className="ppr-a"
            href={`/api/public/${propuesta.doc}`}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            Documentación Anexa
          </a>
        </center>
      )}

      <center>
        <Link
          to={`/municipio/${municipio.nombreUrl}`}
          className="btn ppr-btn-verde font-weight-bold m-2"
        >
          Volver
        </Link>
      </center>
    </MPage>
  );
};

export default withRouter(Propuesta);
